// Shared external links and static config for the Peek landing page.
export const APP_STORE_URL =
  'https://apps.apple.com/us/app/peek-movies-tv-shows/id1374220118';

export const INSTAGRAM_URL = 'https://www.instagram.com/peekthis.app';

export const PRIVACY_EMAIL = 'privacy@peekthis.app';

export const NAV_LINKS = [
  { label: 'Features', href: '#features' },
  { label: 'Peekster', href: '#peekster' },
];
